export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/job_title',
      method: 'GET'
    }]
  },
  add: {
    funKey: 'add',
    name: '新增',
    apis: [{
      path: '/basis/job_title',
      method: 'POST'
    },
    {
      path: '/basis/certificate',
      method: 'GET'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/basis/job_title/{id}',
      method: 'PUT'
    },
    {
      path: '/basis/certificate',
      method: 'GET'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/basis/job_title/{id}',
      method: 'DELETE'
    }]
  }
}